import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index.vue'

// 路由模块
import filesRouter from './modules/files/files'
import contentRouter from './modules/content/content'
import developerRouter from './modules/developer/developer'
import datasRouter from './modules/datas/datas'
import userRouter from './modules/user/user'
import productionRouter from './modules/production/production'
import permissionRouter from './modules/permission/permission'
import approvalRouter from './modules/approval/approval'
import tradeRouter from './modules/trade/index'
// import tradeRouter from './modules/trade/trade'
// import tradeAndroidRouter from './modules/trade/trade-android'
import feedbackRouter from './modules/feedback/feedback'
import paymentRouter from './modules/payment/payment'

Vue.use(Router)

// 路由配置项说明:
/*
  redirect: 设置'noredirect'时不会重定向
  meta: {
    title: 'title'        路由标题: 必传
    icon: 'svg-name'      侧栏 icon 名: 默认无
    breadcrumb: true      是否展示面包屑: 默认展示
    hidden: false         是否加入侧边栏: 默认加入
    showTitle: false      是否置顶路由标题: 默认false,
    alwaysShowMenu: false 是否一直显示侧栏菜单标题
    isNotGenerateMenu:    是否生成侧栏菜单项
  }
*/

const router = new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    // 登录
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/login.vue'),
      meta: { hidden: true }
    },
    // 找回密码
    {
      path: '/find-password',
      name: 'FindPassword',
      component: () => import('@/views/login/find-password.vue'),
      meta: { hidden: true }
    },
    // 重定向
    {
      path: '/redirect',
      component: Layout,
      meta: { hidden: true },
      children: [
        {
          path: '/redirect/:path*',
          component: () => import('@/views/redirect/redirect.vue')
        }
      ]
    },
    // 404页面
    {
      path: '/404',
      component: () => import('@/views/error-page/404.vue'),
      meta: { hidden: true }
    },
    // 首页
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'Home',
          component: () => import('@/views/home/home.vue'),
          meta: {
            breadcrumb: true,
            title: '首页',
            icon: 'menu-home'
          }
        }
      ]
    },
    //  草稿箱
    {
      path: '/draft',
      component: Layout,
      redirect: '/drafts',
      children: [
        {
          path: '/drafts',
          name: 'Drafts',
          component: () => import('@/views/assist/drafts.vue'),
          meta: {
            hidden: true,
            title: '草稿箱'
          }
        }
      ]
    },
    // 个人设置
    {
      path: '/setting',
      component: Layout,
      redirect: '/settings',
      children: [
        {
          path: '/settings',
          name: 'Settings',
          component: () => import('@/views/assist/settings.vue'),
          meta: {
            hidden: true,
            title: '设置'
          }
        }
      ]
    },
    // ********************* 侧栏模块 ***********************
    // 文件信息
    filesRouter,
    // 内容管理
    contentRouter,
    // 开发者
    developerRouter,
    // 用户管理
    userRouter,
    // 订单交易
    tradeRouter,
    // tradeRouter,
    // android订单交易
    // tradeAndroidRouter,
    // 产品发布
    productionRouter,
    // 数据中心
    datasRouter,
    // 支付系统
    paymentRouter,
    // 审批中心
    feedbackRouter,
    // 用户反馈
    approvalRouter,
    // 权限管理
    permissionRouter,
    // 未知路由
    {
      path: '*',
      redirect: '/404',
      meta: { hidden: true }
    }
  ]
})

const originalPush: any = Router.prototype.push
Router.prototype.push = function push(location: any) {
  return originalPush.call(this, location).catch((err: any) => err)
}

export default router
